import type { CareProviderOrganizationsPractitioners } from '@frontend/components/elements/CareProviderSelection';

export function createOrganizationLabel(organization: CareProviderOrganizationsPractitioners) {
    return `${organization.name} ${organization.city ? `(${organization.city})` : ''}`;
}
